import React from 'react';
import { GroupedAvatarComponent } from '../../../../SharedComponents';

const headerData = [
  {
    id: 1,
    label: 'branch',
    input: 'branchName',
  },
  {
    id: 2,
    label: 'active-users',
    input: 'activeUsers',
    component: (row) => {
      while (row.numberOfActiveUserDto?.length < row.numberOfActiveUser) {
        row.numberOfActiveUserDto.push({});
      }
      return (
        <GroupedAvatarComponent
          data={row.numberOfActiveUserDto}
          maxAvatarsNumber={5}
        />
      );
    },
  },
  {
    id: 2,
    label: 'estimated-price',
    input: 'estimatedPrice',
    isNumber: true,
    component: (row) => `${row.estimatedPrice} AED`,
  },
  {
    id: 2,
    label: 'due-date',
    input: 'dueDate',
    isDate: true,
  },
];

export default headerData;
